import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { usePageTitle } from "@/hooks/use-title";

import { TaxFormSubmissionSkeleton } from "./tax-form-submission-skeleton";

export const TaxFormSubmissionPage = () => {
  const { t } = useTranslation();
  usePageTitle(t("tax_form"));

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const url = searchParams.get("url") || "";

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const iframe = document.getElementById(
      "iframe-content"
    ) as HTMLIFrameElement;
    const handleLoad = () => {
      setLoading(false);
    };
    if (iframe) {
      iframe.addEventListener("load", handleLoad);
    }
    return () => {
      if (iframe) {
        iframe.removeEventListener("load", handleLoad);
      }
    };
  }, [url]);

  return (
    <div className="relative w-full h-full">
      {loading && (
        <div className="w-full h-full z-2 bg-white">
          <TaxFormSubmissionSkeleton />
        </div>
      )}
      <iframe
        title="Tax Form Submission"
        id="iframe-content"
        src={url}
        className="w-full h-full border-none z-1"
        width="100%"
        height="100%"
        onLoad={() => setLoading(false)}
      />
    </div>
  );
};
